"use client";

import { cn } from "@repo/shared/utils";
import type { ClassNameValue } from "tailwind-merge";
import { useNestedComponent } from "./hooks/useNestedComponent";

export const Label = ({
  label,
  id,
  className,
  as: Comp = "label",
}: {
  label: React.ReactNode;
  id?: string;
  className?: ClassNameValue;
  as?: React.ComponentType<React.HTMLAttributes<"div">> | string;
}) => {
  const NestedComp = useNestedComponent(Comp);
  return (
    <NestedComp
      className={cn("text-slate-800 text-base leading-5", className)}
      {...(Comp === "label" ? { htmlFor: id } : {})}
    >
      {label}
    </NestedComp>
  );
};
